import { render, staticRenderFns } from "./TipoAtividade.vue?vue&type=template&id=525189b6&scoped=true&"
import script from "./TipoAtividade.vue?vue&type=script&lang=js&"
export * from "./TipoAtividade.vue?vue&type=script&lang=js&"
import style0 from "./TipoAtividade.vue?vue&type=style&index=0&id=525189b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525189b6",
  null
  
)

export default component.exports